import { Component, Injector } from '@angular/core';

import { BaseFormComponent } from '../base-form.component';

@Component({
  moduleId: module.id,
  selector: 'custom-address-short',
  templateUrl: './custom-address-short.component.html',
})
export class CustomAddressShortComponent extends BaseFormComponent {
  // pointers to the full model path for data binding
  cityProp: string;
  stateProp: string;

  city: string;
  state: string;

  constructor(protected injector: Injector) {
    super(injector);

    this.questionItem = this.injector.get('questionItem');

    this.cityProp = `${this.questionItem.prop}.${this.questionItem.customProps[0]}`;
    this.stateProp = `${this.questionItem.prop}.${this.questionItem.customProps[1]}`;

    this.setVisibility();
    this.updateFromModel();
  }

  updateFromModel() {
    const city = this.getValue(this.cityProp);
    const state = this.getValue(this.stateProp);

    if (city !== this.city) {
      this.city = city;
    }
    if (state !== this.state) {
      this.state = state;
    }
  }

  resetValue() {
    this.city = null;
    this.state = null;
  }

  getErrorMessage(propName): string {
    const regex = new RegExp(propName);
    for (const key in this.errorMessage) {
      if (key.match(regex)) {
        return this.errorMessage[key];
      }
    }
    return '';
  }

  async triggerCity() {
    await this.validateAndSet(this.cityProp, this.city);
  }

  async triggerState() {
    await this.validateAndSet(this.stateProp, this.state);
  }
}
